<div [formGroup]="form">
  <div [formGroupName]="field.formGroup" *ngIf="field.formGroup">
    <swb-form-field [field]="field" [form]="form"></swb-form-field>
  </div>
  <div *ngIf="!field.formGroup">
    <swb-form-field [field]="field" [form]="form"></swb-form-field>
  </div>
</div>